// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__YDFcb","label":"LoginForm_label__F7sLE","button":"LoginForm_button__LodJg","inputContainer":"LoginForm_inputContainer__rhDXw"};